var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "container-income-report" }, [
    _c(
      "div",
      {
        staticClass: "custom-nav-block",
        style: `padding-top:${_vm.barHeight}px`,
      },
      [
        _c("van-nav-bar", {
          staticClass: "van-bar",
          attrs: { title: "", "left-arrow": "" },
          scopedSlots: _vm._u([
            {
              key: "left",
              fn: function () {
                return [
                  _c(
                    "div",
                    {
                      staticStyle: { display: "flex", "align-items": "center" },
                      on: { click: _vm.handleBackPath },
                    },
                    [
                      _c("img", {
                        staticClass: "left-nav",
                        attrs: {
                          src: require("@/assets/packageAssets/common/arrow05.png"),
                          alt: "",
                        },
                      }),
                      _vm._v(
                        " " + _vm._s(_vm.$t("lang.mybean.incomeReport")) + " "
                      ),
                    ]
                  ),
                ]
              },
              proxy: true,
            },
          ]),
        }),
      ],
      1
    ),
    _c(
      "div",
      { staticClass: "report-swipe" },
      [
        _c(
          "swiper",
          {
            ref: "mySwiper",
            staticClass: "my-swiper",
            attrs: { options: _vm.swiperOptions },
          },
          _vm._l(_vm.serviceAdvantageData, function (item) {
            return _c("swiper-slide", { key: item.id }, [
              _c(
                "div",
                {
                  staticClass: "card-box",
                  style: {
                    background: `url(${item.image})`,
                    "background-size": "100% 100%",
                  },
                },
                [
                  _c("span", { staticClass: "card-title" }, [
                    _vm._v(_vm._s(_vm.$t("lang.mybean.weeklyIncome"))),
                  ]),
                  _c("div", { staticClass: "card-beans" }, [
                    _c("i", [_vm._v(_vm._s(_vm.data.amount))]),
                    _c("img", {
                      attrs: { src: _vm.getMatchImg("beans"), alt: "" },
                    }),
                  ]),
                  _c("span", { staticClass: "card-time" }, [
                    _vm._v(
                      _vm._s(_vm.data.weekStart) +
                        "-" +
                        _vm._s(_vm.data.weekEnd)
                    ),
                  ]),
                ]
              ),
            ])
          }),
          1
        ),
      ],
      1
    ),
    _c(
      "div",
      { staticClass: "report-list" },
      _vm._l(_vm.listDay, function (item) {
        return _c(
          "div",
          {
            key: item,
            staticClass: "list-item",
            on: {
              click: function ($event) {
                return _vm.toPage(item.day)
              },
            },
          },
          [
            _c("div", { staticClass: "time" }, [_vm._v(_vm._s(item.day))]),
            _c("div", { staticClass: "beans" }, [
              _c("span", [_vm._v(_vm._s(item.amount))]),
              _c("img", { attrs: { src: _vm.getMatchImg("beans"), alt: "" } }),
              _c("img", {
                staticClass: "arraw",
                attrs: {
                  src: require("@/assets/packageAssets/common/arrow05.png"),
                  alt: "",
                },
              }),
            ]),
          ]
        )
      }),
      0
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }